import {
    Platform,
    View
} from "react-native";
import type {
    SelectBoxDataComparisonConstantType,
    SelectBoxControlElementConstantType,
    SelectBoxValueItemsConstantType,
    SelectBoxValueConstantType,
    SelectBoxValue,
    SelectedItem
} from "./type";

const getIsView = (value: unknown): value is View => {
    if(typeof HTMLElement !== "undefined" && value instanceof HTMLElement) {
        return true;
    }

    return typeof value === "object" && value !== null && "measureInWindow" in value;
};

export const getSelectBoxControlElement = ({
    node
}: SelectBoxControlElementConstantType): View | null => {
    if(Platform.OS !== "web" || typeof HTMLElement === "undefined" || !(node instanceof HTMLElement)) {
        return node;
    }

    const parent = node.parentElement;

    return getIsView(parent) ? parent : node;
};

export const getIsSameSelectBoxData = <T>({
    current,
    next
}: SelectBoxDataComparisonConstantType<T>): boolean => {
    if(current.length !== next.length) {
        return false;
    }

    return current.every((item, index) => item === next[index]);
};

export const getSelectBoxValueKeys = (value?: SelectBoxValue): Array<string> => {
    if(value === undefined) {
        return [];
    }

    if(typeof value === "string") {
        return value ? [value] : [];
    }

    return value;
};

export const getSelectBoxValue = ({
    isMultipleSelect,
    selectedItems
}: SelectBoxValueConstantType): SelectBoxValue => {
    if(isMultipleSelect) {
        return selectedItems.map((item) => item.__key);
    }

    return selectedItems[0]?.__key ?? "";
};

export const getSelectBoxValueItems = ({
    known,
    keys,
    data
}: SelectBoxValueItemsConstantType): Array<SelectedItem> => {
    return keys.map((key) => {
        const item = data.find((dataItem) => dataItem.__key === key) ?? known.find((knownItem) => knownItem.__key === key);

        return {
            __title: item ? item.__title : key,
            __key: key
        };
    });
};
